import React, { createContext, useContext } from 'react';
import { useMCStates } from '../hooks/useMCStates';

const MCContext = createContext<any>(null);

export const MCProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const mcStates = useMCStates();
    return (
        <MCContext.Provider value={mcStates}>
            {children}
        </MCContext.Provider>
    );
};


export const useMCContext = () => {
    const context = useContext(MCContext);

    if (!context) {
        throw new Error('useMCContext must be used within a MCProvider');
    }
    return context;

};